import { render, staticRenderFns } from "./training-plan-show.vue?vue&type=template&id=1723bddc&scoped=true&"
import script from "./training-plan-show.vue?vue&type=script&lang=js&"
export * from "./training-plan-show.vue?vue&type=script&lang=js&"
import style0 from "./training-plan-show.vue?vue&type=style&index=0&id=1723bddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1723bddc",
  null
  
)

export default component.exports